module.exports = __webpack_public_path__ + "b3d14b5c7889331b3b7aab84b2007aa8.svg";